export default {
  computed: {
    pdm() {
      return this.$store.state.utils.pdm;
    },
    activeComponent() {
      return this.$store.state.legacyNavigation.activeComponent;
    },
    recipe_v2() {
      return this.$store.state.recipe.recipe_v2;
    },
    upgradeOptionsStore(){
      return this.$store.state.geometryUpdates.upgradeOptions;
    },
    isApparelEnabled() {
      return this.$store.getters['utils/isApparelEnabled'];
    },
    isFinishMyDesignApplied() {
      return this.$store.state.utils.isFinishMyDesignApplied;
    },
    hasUndoChanges() {
      return !!this.$store.state.undo.previousSwatch.length || !!Object.keys(this.$store.state.undo.previousRecipe).length;
    },
  },
  methods: {
    /**
     * @function validateMerchandisingRules
     * @param {string} geometryUpdate
     * Validates the current geometry change and allows it to continue or rejects it based on merchandising rules
     * Comparing what is on the recipe vs the merchandising rules on the pdm.
     */
    validateMerchandisingRulesRecipe({ componentName, geometryUpdate }) {
      const recipe = this.recipe_v2.components;
      const validation = Object.keys(recipe).filter(component => {
        let swatchObj = this.$store.getters['swatches/returnSwatchObj']({ swatchId: recipe[component].swatch_id });
        let swatchGeometrics = swatchObj && swatchObj.geometry_updates;
        if (recipe[component].group === "ugc" && recipe[component].subgroup !== "ugc") {
          swatchGeometrics =  this.isGeoUpdateFromFeature({
            componentName: component,
            geometrySwatch: swatchObj && swatchObj.geometry_updates,
            geometryUpdate,
          });
        }
        let merchRemove = this.pdm && this.pdm.merchandising_rules
          && this.pdm.merchandising_rules.swatches
          && this.pdm.merchandising_rules.swatches[geometryUpdate]
          && this.pdm.merchandising_rules.swatches[geometryUpdate].remove;
        let removeGeo = merchRemove && merchRemove.filter(geo => {
          return swatchGeometrics && swatchGeometrics.includes(geo)
        });
        return (removeGeo && removeGeo.length > 0) && componentName !== component;
      });
      return validation.length > 0;
    },
    /**
     * @function validateMerchandisingRules
     * @param {string} geometryUpdate
     * @param {string} componentName
     * @param {boolean} applyingRecipe
     * Validates the current geometry change and allows it to continue or rejects it based on merchandising rules on the PDM
     */
    validateMerchandisingRulesPDM({geometryUpdate, componentName, applyingRecipe}) {
      if (!this.pdm.merchandising_rules) return true; //temp fix for models without merch rules
      const geoUpdate = this.pdm.components[componentName].geometry_updates;
      const geoInComponent = geoUpdate && geoUpdate.includes(geometryUpdate);
      const skipComponentValidation = this.pdm.merchandising_rules
        && this.pdm.merchandising_rules.swatches
        && this.pdm.merchandising_rules.swatches[geometryUpdate]
        && this.pdm.merchandising_rules.swatches[geometryUpdate].skipComponentValidation;
      const default_state = this.pdm.merchandising_rules
        && this.pdm.merchandising_rules.swatches
        && this.pdm.merchandising_rules.swatches[geometryUpdate]
        && this.pdm.merchandising_rules.swatches[geometryUpdate].default_state;
      let accountForApplyRecipe = false;

      if (applyingRecipe) accountForApplyRecipe = default_state;

      return (geoInComponent || skipComponentValidation) && !accountForApplyRecipe;
    },
    /**
     * @function updateRecipeWithMerchandisingSwatchRules
     * @param {string} geometryUpdate
     * @param {string} componentName
     * Updates the recipe based on the merchadising rules on the PDM and on the swatch
     */
    updateRecipeWithMerchandisingSwatchRules({swatch, componentName}) {
      if (this.pdm.merchandising_rules && swatch.geometry_updates) {
        swatch.geometry_updates.forEach(geometryUpdate => {
          if(this.validateMerchandisingRulesPDM({geometryUpdate, componentName})) {
            const rules = this.pdm.merchandising_rules.swatches[geometryUpdate];
            if(rules && rules.deactivate_components) {
              this.deactivateComponents({componentsToDeactivate: rules.deactivate_components, activeComponent: componentName, swatchId: swatch.id, removeFromRecipe: true})
            }

            if(rules && rules.activate_components) {
              this.activateComponents({
                componentsToActivate: rules.activate_components,
                activeComponent: componentName,
                swatchId: swatch.id
              });
            }

            if (rules && rules.remove_personalization) {
              this.$personalization.removePersonalization();
            }
          }
        })
      }
    },
    deactivateComponents({componentsToDeactivate, activeComponent, removeFromRecipe, swatchId}){
      componentsToDeactivate.forEach(componentName => {
        const componentGroup = this.$store.state.componentConfigGroup.componentsParentChildConfiguration[activeComponent];
        if (componentGroup) {
          if(!componentGroup.includes(componentName)) componentGroup.push(componentName);
          this.$store.commit("componentConfigGroup/SET_COMPONENT_PARENT_CHILD_CONFIGURATION", {
            parentComponent: activeComponent,
            componentGroup
          });
          const defaultSwatch = this.$store.state.recipe.defaultRecipe.components[componentName];
          if (defaultSwatch) {
            this.$store.commit("swatches/SET_SWATCHES_SELECTED", {
              component: componentName,
              data: {
                group: defaultSwatch.group,
                subgroup: defaultSwatch.subgroup,
                swatchId: defaultSwatch.swatch_id
              }
            });
          }
          this.$recipe.updateComponents(componentName, swatchId, componentsToDeactivate);
        }
        if(removeFromRecipe) this.$store.commit("recipe/REMOVE_COMPONENT", componentName);
        this.$store.commit("legacyNavigation/CHANGE_MENU_ITEM_VISIBILITY", { componentName, visible: false });
        this.$store.commit("standardNavigation/UPDATE_MENU_STANDARD_NAVIGATION", { item: {id: componentName, visible: false }});
      })
    },
    activateComponents({ componentsToActivate, activeComponent, swatchId }) {
      const { swatchesListByComponent } = this.$store.state.swatches;
      const defaultRecipeComponents = this.$store.state.recipe.defaultRecipe.components;

      componentsToActivate.forEach(componentName => {
        const componentGroup = this.$store.state.componentConfigGroup.componentsParentChildConfiguration[activeComponent];
        const parentComponentName = this.pdm.components[componentName].parent_component;

        if (componentGroup) {
          const group = componentGroup.filter(item => item !== componentName);
          this.$store.commit("componentConfigGroup/SET_COMPONENT_PARENT_CHILD_CONFIGURATION", {
            parentComponent: activeComponent,
            componentGroup: group
          });
        }

        // get the swatch to apply to the newly created component, if there is a parent component apply the swatch the parent has
        const currentComponent = parentComponentName || componentName;

        if(!this.recipe_v2.components[componentName]) {
          this.$store.commit("recipe/CREATE_COMPONENT", componentName);
        }
        const prevSwatch = this.$store.state.swatches.selectedSwatches[currentComponent]
          && this.$store.state.swatches.selectedSwatches[currentComponent].swatchId;
        const defaultSwatchID = defaultRecipeComponents[currentComponent]?.swatch_id;
        let swatchIdToApply = null;
        if (this.hasUndoChanges && !this.isFinishMyDesignApplied &&
          !swatchesListByComponent?.[componentName] && !defaultRecipeComponents[componentName]) {
          swatchIdToApply = swatchId || prevSwatch || defaultSwatchID;
        } else {
          swatchIdToApply = prevSwatch || defaultSwatchID || swatchId;
        }

        // apply swatch
        this.applySwatch(componentName, swatchIdToApply);
        this.$store.commit("legacyNavigation/CHANGE_MENU_ITEM_VISIBILITY", { componentName, visible: true });
        this.$store.commit("standardNavigation/UPDATE_MENU_STANDARD_NAVIGATION", { item: {id: componentName, visible: true }});
      })
    },
    validateMerchandisingByPDMComponent({rule, componentName, validActiveComponent = true}){
      const component = this.pdm.components[componentName];
      const merchRuleInComponent = component && component.merchandising_rules && component.merchandising_rules.includes(rule);
      if (merchRuleInComponent &&  (validActiveComponent ? componentName === this.activeComponent : true)) {
        return true;
      }

      return false;
    },
    /**
     * This method it is only for merchandising_rules that doesn't have
     * geometry_updates for example foxing or suede in backpack
     * @swatch {*} swatch obj
     */
    applyMerchRulesAfterSwatch({swatch, componentName}) {
      const defaultComponent = this.$store.state.recipe.defaultRecipe.components[componentName];

      // TODO fix apparel to work with this
      if (this.isApparelEnabled) return;

      if (this.isFinishMyDesignApplied && Number(swatch.id) === Number(defaultComponent?.swatch_id))
        return;

      if (this.pdm.merchandising_rules) {
        const merchRules = this.pdm && this.pdm.merchandising_rules && this.pdm.merchandising_rules.swatches;
        const geoUpdates = this.pdm && this.pdm.geometry_updates && this.pdm.geometry_updates.swatches;
        const merchRulesSwatch = swatch.merchandising_rules;

        if (merchRulesSwatch) {
          merchRulesSwatch.forEach((rule) => {
            const currentRule = merchRules[rule];
            const geoValidation = !geoUpdates || (geoUpdates && !geoUpdates[merchRules]);
            const validRuleInComponent = this.validateMerchandisingByPDMComponent(
              { rule, componentName, validActiveComponent: false },
            );

            if (currentRule && validRuleInComponent && geoValidation) {
              const params = { activeComponent: componentName, swatchId: swatch.id };

              if (currentRule.activate_components && !currentRule.activate_components.includes(componentName)) {
                this.activateComponents({ componentsToActivate: currentRule.activate_components, ...params });
              }
              if (currentRule.deactivate_components) {
                this.deactivateComponents({ componentsToDeactivate: currentRule.deactivate_components, ...params });
              }
            }
          });
        }
      }
    },
    applyUpgradeOptions({upgradeOptions, swatchId}){
      let upgradeOptionStatus =(this.upgradeOptionsStore[swatchId]
        && this.upgradeOptionsStore[swatchId].status);
      let resultUpgradeStatus = true;

      if(upgradeOptions){
        const promises = [];
        const upgradeOptionsPDM = this.pdm && this.pdm.upgrade_options;
        upgradeOptions.forEach(option => {
          const optionPDM = upgradeOptionsPDM[option];
          let componentGroup;

          if (upgradeOptionStatus){
            const parentSwatch = this.recipe_v2.components[optionPDM.parent_component].swatch_id;
            componentGroup = this.pdm.components[optionPDM.parent_component].component_configuration_group;
            promises.push(this.applySwatch(optionPDM.secondary_component, parentSwatch));
            resultUpgradeStatus = false;
          } else {
            const swatchObj = this.$store.getters["swatches/returnSwatchObj"]({ swatchId })
            const group = this.$store.getters["swatches/returnSwatchGroupName"]({ swatch:  swatchObj })
            const subgroup = this.$store.getters["swatches/returnSwatchSubgroupName"]({ swatch: swatchObj })
            componentGroup = optionPDM.component_configuration_group
            promises.push(this.applySwatch(optionPDM.secondary_component, swatchId));
            this.$store.commit("swatches/SET_SWATCHES_SELECTED", {
              component: optionPDM.secondary_component,
              data: {
                group,
                subgroup,
                swatchId
              }
            });
          }

          this.$store.commit("geometryUpdates/SET_COMPONENT_DISABLED", {componentName: optionPDM.secondary_component, disabled: resultUpgradeStatus});
          this.$store.commit("componentConfigGroup/SET_COMPONENT_PARENT_CHILD_CONFIGURATION", {
            parentComponent: optionPDM.parent_component,
            componentGroup
          });
        });
        this.$store.commit("geometryUpdates/SET_UPGRADE_OPTIONS", {
          swatchId: swatchId,
          status: resultUpgradeStatus
        });
        return Promise.all(promises);
      }
    },
    validateComponentGrouping({componentName}){
      const PDM = this.pdm.components[componentName] && this.pdm.components[componentName].component_configuration_group;
      const configGroupConfig = this.$store.state.componentConfigGroup.componentsParentChildConfiguration[componentName];
      return configGroupConfig || PDM;
    },
    selfRemoveSwatches({swatch}) {
      if(swatch && swatch.self_removable) {
        const selfRemovable = Object.keys(this.recipe_v2.components).find(comp => {
          const swatch = this.$store.getters["swatches/returnSwatchObj"]({ "swatchId": this.recipe_v2.components[comp].swatch_id });
          return swatch && swatch.self_removable;
        });
        const upgradeOptions = this.$store.state.geometryUpdates.upgradeOptions;
        const recipeComp = this.recipe_v2.components[selfRemovable];
        let status = upgradeOptions && upgradeOptions[recipeComp && recipeComp.swatch_id] && upgradeOptions[recipeComp && recipeComp.swatch_id].status;
        if(status) this.$store.commit('geometryUpdates/SET_UPGRADE_OPTIONS', { swatchId: recipeComp.swatch_id, status: false });
      }
    },
    resetUpgradeOptions() {
      const { default_component } = this.pdm;
      const merchandisingRules = this.pdm?.merchandising_rules?.swatches;
      let merchandisingRulesDefaultRemove = null;
      if(merchandisingRules) {
        const merchandisingRulesDefault  =  Object.keys(merchandisingRules)?.filter( data => merchandisingRules?.[data]?.default_state === true);
        merchandisingRulesDefaultRemove = merchandisingRules[merchandisingRulesDefault?.[0]]?.remove || null;
      }
      let promises = [];

      Object.keys(this.recipe_v2.components).forEach(component => {
        let componentObject = this.recipe_v2.components[component];
        const swatchObj =  this.$store.getters['swatches/returnSwatchObj']({ swatchId: componentObject.swatch_id });
        let swatchGroup = swatchObj &&
          this.$store.getters['swatches/returnSwatchGroupName']({ swatch: swatchObj });
        let swatchSubgroup = swatchObj &&
        this.$store.getters['swatches/returnSwatchSubgroupName']({ swatch: swatchObj });

        if (swatchObj?.upgrade_options) {
          promises.push(this.applyUpgradeOptions({upgradeOptions: swatchObj.upgrade_options, swatchId: swatchObj.id}));
        } else {
          if(swatchObj?.geometry_updates) {
            for (let geometryName of swatchObj.geometry_updates) {

              if (swatchGroup === "upgradeoptions" || (swatchSubgroup === "branding" && swatchObj.self_removable)) {
                const geosToRemove =  this.pdm?.geometry_updates?.swatches?.[geometryName]?.remove_geo;
                const componentsToDeactivate = this.pdm?.merchandising_rules?.swatches[geometryName]?.deactivate_components;
                if(geosToRemove) {
                  this.removeGeos({geosToRemove: this.setGeosToRemove({geosToRemove})});
                  this.deactivateComponents({ componentsToDeactivate: componentsToDeactivate
                        || geosToRemove, activeComponent: default_component});
                  this.$store.commit('geometryUpdates/SET_UPGRADE_OPTIONS', {
                    swatchId: swatchObj.id,
                    status: false
                  });
                }
              }
              /*Reseat vans_logo into the 3d*/
              if(merchandisingRules && merchandisingRulesDefaultRemove && merchandisingRulesDefaultRemove.includes(geometryName)) {
                const swatch =  this.$store.getters['swatches/returnSwatchObj']({ swatchId: this.$store.state.recipe.defaultRecipe.components[component].swatch_id });
                promises.push(this.updateModelGeometry({ componentName: component, applyingRecipe: false, swatchObj: swatch }));
              }
            }
          }
        }
      });

      return Promise.all(promises);
    }
  }
};
